export default __webpack_public_path__ + "static/media/complain.90686cc8.png";